import React from 'react'
import { useTranslation } from 'react-i18next'
import ChatBotBanner from './sections/chatbotBanner'

import './chatbot.scss'
import ChatExpert from './sections/chatExpert'
import NeedHelp from './sections/needHelp'

import LetsGo from '../connectors/letsgo'
import Governance from './sections/governance'
import CustomerTestimonials from './sections/customerTestimonials'

function ChatBotPage() {

    return (
        <div className="container-chatbot">
            <div className="section-chatbot-banner">
                <ChatBotBanner />
            </div>
            <div className="section-chatbot-expert">
                <ChatExpert />
            </div>
            <div className="section-chatbot-need-help">
                <NeedHelp />
            </div>
            <div className="section-letsgo">
                <LetsGo />
            </div>
        </div>
    )
}

export default ChatBotPage